module.exports = __webpack_public_path__ + "img/badge_special_simple.9dc0da6c.png";